<template>
  <div
    v-if="!permission.capabilities.View"
    class="animated fadeIn content-holder"
  >
    <Page403></Page403>
  </div>
  <div v-else class="animated fadeIn content-holder">
    <!-- input show -->
    <b-card no-body>
      <b-card-header class="custom-header">
        <div><i class="icon-people mr-1"></i>Search QR</div>
      </b-card-header>
      <b-card-body v-if="isLoading">
        <spinner></spinner>
      </b-card-body>
      <b-card-body v-else>
        <b-form>
          <b-row>
            <b-col md="12">
              <b-row>
                <b-col md="3">
                  <label id="company" class="d-block">company</label>
                  <b-form-select
                    id="selectCompany"
                    label="company"
                    class="form-group"
                    :options="this.companiesOptions"
                    v-model="companyId"
                  ></b-form-select>
                </b-col>

                <b-col md="3">
                  <label id="products" class="d-block">Products</label>
                  <b-form-select
                    id="selectproduct"
                    label="product"
                    class="form-group"
                    :options="this.productsOptions"
                    v-model="productId"
                    @change="handleChangeProduct($event)"
                  ></b-form-select>
                </b-col>
                <b-col md="3">
                  <label id="wallet" class="d-block">Wallets</label>
                  <b-form-select
                    id="selectwallet"
                    label="wallet"
                    class="form-group"
                    :options="this.walletsOptions"
                    v-model="walletId"
                    @change="handleChangeWallet($event)"
                  ></b-form-select>
                </b-col>
                <b-col md="3">
                  <label id="segments" class="d-block">Segments</label>
                  <b-form-select
                    id="selectsegments"
                    label="segments"
                    class="form-group"
                    :options="this.segmentsOptions"
                    v-model="setId"
                  ></b-form-select>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="2">
                  <b-form-group
                    id="limit"
                    label="Record Limit"
                    label-for="firstname"
                  >
                    <b-form-input
                      id="limit"
                      type="number"
                      v-model="limit"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="5">
                  <b-form-group
                    id="nameInputGroup1"
                    label="Qr Code"
                    label-for="qrCode"
                  >
                    <b-form-input
                      id="qrCode"
                      type="text"
                      v-model="qrCode"
                      aria-describedby="input1LiveFeedback1"
                      placeholder="Qr Code"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="5">
                  <b-form-group
                    id="nameInputGroup2"
                    label="Protect Code"
                    label-for="protectCode"
                  >
                    <b-form-input
                      id="protectCode"
                      type="text"
                      v-model="protectCode"
                      aria-describedby="input1LiveFeedback1"
                      placeholder="Protect Code"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12" class="text-center">
                  <b-button variant="primary" @click="search()">
                    <i class="fa fa-search"></i> Search
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
    </b-card>
    <b-card no-body>
      <b-card-header class="custom-header">
        <div><i class="icon-people mr-1"></i>List QR Code</div>
      </b-card-header>
      <b-card-body v-if="isListingLoading">
        <spinner></spinner>
      </b-card-body>
      <b-card-body v-else>
        <b-card-group deck class="mb-5" v-for="(qr, index) in pages[currentPage - 1]" :key="index" style="width: 50%; float: left; margin: 0 auto;">
          <b-card style="max-width: 93%;">
            <div class="row no-gutters">
              <div class="col-md-4">
                <img :src="qr.s3_path" class="card-img" @error="imgPlaceholder" />
              </div>
              <div class="col-md-8">
                <div class="card-body">
                  <h5 class="card-title"><a :href="`${qr.qr_link}`">{{ qr.set_qr_codes }}</a></h5>
                  <p class="card-text">
                    <ul class="list">
                      <li><b>Wallet:</b> {{ qr.wallet_name }}</li>
                      <li><b>Protect Code:</b> {{ qr.set_protect_codes }}</li>
                      <li><b>Segment:</b> {{ qr.segment_name }}</li>
                    </ul>
                  </p>
                </div>
              </div>
            </div>
          </b-card>
        </b-card-group>
      </b-card-body>
      <div v-if="isListing">
        <b-pagination v-model="currentPage" :total-rows="totalPages"></b-pagination>
      </div>
    </b-card>
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import miniToastr from "mini-toastr";
import { apigClient } from "@/shared/api";
import { router } from "../../router/index";
import Page403 from "@/views/pages/Page403.vue";

const Spinner = () => import("../shared/Spinner");
const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};
miniToastr.init({ types: toastTypes });

function toast({ title, message, type, timeout, cb }) {
  return miniToastr[type](message, title, timeout, cb);
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
};
Vue.use(VueNotifications, options);
let user = JSON.parse(localStorage.getItem("loginUserInfo"));
const qrRole = "Not a  data";
const qrGroup = "foo";

export default {
  group_name: "Test",
  components: {
    Event,
    Spinner,
    Page403
  },
  data: function() {
    let loginUserInfo = JSON.parse(localStorage.getItem("loginUserInfo"));
    return {
      loginUserInfo: loginUserInfo,
      permission: {
        permissionBaseName: null,
        permissionBaseNameCapabilities: null,
        capabilities: {
          View: false,
          Edit: false,
          Delete: false,
          Create: false
        }
      },
      data: [],
      pages: [],
      totalPages: 0,
      isLoading: true,
      isListing: false,
      isListingLoading: false,
      perPage: 20,
      currentPage: 1,
      limit: 100,
      useVuex: false,
      theme: "bootstrap4",
      template: "default",
      //For delete modal
      deleteModalOpen: false,
      qrCode: null,
      protectCode: null,
      companyId: null,
      productId: null,
      walletId: null,
      setId: null,
      companiesOptions: [],
      productsOptions: [],
      walletsAllOptions: [],
      walletsOptions: [],
      segmentsOptions: [],
      segmentsAllOptions: []
    };
  },
  methods: {
    imgPlaceholder(e) {
      e.target.src = '/img/no_image_available.jpeg';
    },
    getPermission() {
      let that = this;
      const userPermissionsBasedOnEntity =
        that.loginUserInfo.db.userPermissionsBasedOnEntity;
      if (this.$route.meta && userPermissionsBasedOnEntity) {
        that.permission.permissionBaseName = this.$route.meta.permissionBaseName;
        let userPermissionBasedOnEntity = userPermissionsBasedOnEntity.find(
          p => p.permissionBaseName === this.$route.meta.permissionBaseName
        );
        if (userPermissionBasedOnEntity) {
          that.permission.permissionBaseNameCapabilities =
            userPermissionBasedOnEntity.capabilities;
          that.permission.permissionBaseNameCapabilities.forEach(capability => {
            that.permission.capabilities[capability.label] = capability.value;
          });
        }
      } else {
        router.push("/no-permission-given");
      }
    },
    handleChangeProduct(event) {
      this.walletsOptions = this.walletsAllOptions.filter(
        e => e.product_id === event
      );
    },
    handleChangeWallet(event) {
      this.segmentsOptions = this.segmentsAllOptions.filter(
        e => e.wallet_id === event
      );
    },
    getCompaniesData: function() {
      var method = "GET";
      var pathTemplate = "/companies";
      var additionalParams = {
        queryParams: {
          params: JSON.stringify({
            table: "company",
            fields: ["id, companyName"],
            filter: [
              {
                fieldname: "id",
                comparisonOperator: "=",
                value: this.companyId
              },
              {
                fieldname: "isDeleted",
                comparisonOperator: "=",
                value: false
              }
            ]
          })
        }
      };
      var pathParams = {};
      var userDatas = [];
      var that = this;
      return apigClient
        .invokeApi(pathParams, pathTemplate, method, additionalParams)
        .then(function(result) {
          let response = result.data;
          if (response.status) {
            return response.data;
          } else {
            that.showErrorMsg({ message: response.message });
            return { error: response.message };
          }
        })
        .catch(function(error) {
          that.showErrorMsg({ message: error.message });
          return { error: error.message };
        });
    },
    getProductsData: function() {
      var method = "GET";
      var pathTemplate = "/products";
      var additionalParams = {
        queryParams: {
          params: JSON.stringify({
            filter: [
              {
                fieldname: "company_id",
                comparisonOperator: "=",
                value: this.companyId
              },
              {
                fieldname: "isDeleted",
                comparisonOperator: "=",
                value: false
              }
            ]
          })
        }
      };
      var pathParams = {};
      var userDatas = [];
      var that = this;
      return apigClient
        .invokeApi(pathParams, pathTemplate, method, additionalParams)
        .then(function(result) {
          let response = result.data;
          if (response.status) {
            return response.data;
          } else {
            that.showErrorMsg({ message: response.message });
            return { error: response.message };
          }
        })
        .catch(function(error) {
          that.showErrorMsg({ message: error.message });
          return { error: error.message };
        });
    },
    getWalletsData: function() {
      var method = "GET";
      var pathTemplate = "/wallets";
      var additionalParams = {
        queryParams: {
          params: JSON.stringify({
            filter: [
              {
                fieldname: "company_id",
                comparisonOperator: "=",
                value: this.companyId
              },
              {
                fieldname: "isDeleted",
                comparisonOperator: "=",
                value: false
              }
            ]
          })
        }
      };
      var pathParams = {};
      var userDatas = [];
      var that = this;
      return apigClient
        .invokeApi(pathParams, pathTemplate, method, additionalParams)
        .then(function(result) {
          let response = result.data;
          if (response.status) {
            return response.data;
          } else {
            that.showErrorMsg({ message: response.message });
            return { error: response.message };
          }
        })
        .catch(function(error) {
          that.showErrorMsg({ message: error.message });
          return { error: error.message };
        });
    },
    getSegmentsData: function() {
      var method = "GET";
      var pathTemplate = "/wallet-segments";
      var additionalParams = {
        queryParams: {
          params: JSON.stringify({
            filter: [
              {
                fieldname: "company_id",
                comparisonOperator: "=",
                value: this.companyId
              },
              {
                fieldname: "isDeleted",
                comparisonOperator: "=",
                value: false
              }
            ]
          })
        }
      };
      var pathParams = {};
      var userDatas = [];
      var that = this;
      return apigClient
        .invokeApi(pathParams, pathTemplate, method, additionalParams)
        .then(function(result) {
          let response = result.data;
          if (response.status) {
            return response.data;
          } else {
            that.showErrorMsg({ message: response.message });
            return { error: response.message };
          }
        })
        .catch(function(error) {
          that.showErrorMsg({ message: error.message });
          return { error: error.message };
        });
    },
    qrcodesListing: function(option) {
      this.isListingLoading = true;
      let method = "POST";
      let additionalParams = {};
      let pathParams = {};
      let dataResult = [];
      let pathTemplate = `/qrcodes/listing`;
      let that = this;
      var body = {
        qrCode: this.qrCode,
        protectCode: this.protectCode,
        companyId: this.companyId,
        productId: this.productId,
        walletId: this.walletId,
        setId: this.setId,
        limit: this.limit
      };
      apigClient
        .invokeApi(pathParams, pathTemplate, method, additionalParams, body)
        .then(function(result) {
          that.data = result["data"]["data"];
          that.totalPages = that.data.length;
          if (that.data.length > 20) {
            that.pages = that.chunk(that.data, 20);
          } else {
            that.pages = that.data;
          }
          that.isListing = true;
          that.isListingLoading = false;
        })
        .catch(function(error) {
          that.showErrorMsg({ message: error });
          that.isListing = true;
          that.isListingLoading = false;
        });
    },
    chunk: function(array, size) {
      var results = [];
      while (array.length) {
        results.push(array.splice(0, size));
      }
      return results;
    },
    search: function() {
      this.waitLoad = true;
      this.qrcodesListing();
    },
    getProductData: async function(req) {
      var method = "GET";
      var pathTemplate = "/products/" + req;
      var additionalParams = {};
      var pathParams = {};
      var userDatas = [];
      var that = this;
      var res = "";
      await apigClient
        .invokeApi(pathParams, pathTemplate, method, additionalParams)
        .then(function(result) {
          if (result.data.status) {
            let data = result["data"]["data"];
            res = data.product_name;
          } else {
            that.showErrorMsg({ message: result.data.message });
          }
        })
        .catch(function(error) {
          that.showErrorMsg({ message: error.message });
          that.isLoading = false;
        });
      return res;
    }
  },
  mounted: function() {
    this.getPermission();
    if (!this.permission.capabilities.View) {
      return;
    }

    const user = JSON.parse(localStorage.getItem("loginUserInfo"));
    this.companyId =
      user.db.company.id == null ||
      user.db.company.id == undefined ||
      user.db.company.id == "NULL"
        ? ""
        : user.db.company.id;
    Promise.all([
      this.getCompaniesData(),
      this.getProductsData(),
      this.getWalletsData(),
      this.getSegmentsData()
    ]).then(data => {
      if (data[0] && data[0].length > 0) {
        data[0].map(company => {
          let companiesJSON = {};
          companiesJSON.value = company.id;
          companiesJSON.text = company.companyName;
          this.companiesOptions.push(companiesJSON);
        });
      }
      if (data[1] && data[1].length > 0) {
        data[1].map(product => {
          let productsListJSON = {};
          productsListJSON.value = product.id;
          productsListJSON.text = product.product_name;
          this.productsOptions.push(productsListJSON);
        });
      }
      if (data[2] && data[2].length > 0) {
        data[2].map(wallet => {
          let walletsJSON = {};
          walletsJSON.product_id = wallet.product_id;
          walletsJSON.value = wallet.id;
          walletsJSON.text = wallet.walletName;
          this.walletsAllOptions.push(walletsJSON);
        });
      }
      if (data[3] && data[3].length > 0) {
        data[3].map(segment => {
          let segmentsJSON = {};
          segmentsJSON.wallet_id = segment.wallet_id;
          segmentsJSON.value = segment.id;
          segmentsJSON.text = segment.walletSegmentName;
          this.segmentsAllOptions.push(segmentsJSON);
        });
      }
      this.isLoading = false;
    });
  },
  notifications: {
    showInfoMsg: {
      type: VueNotifications.types.info,
      title: "Info",
      message: "Here is some info for you"
    },
    showWarnMsg: {
      type: VueNotifications.types.warn,
      title: "Warning",
      message: "That's the kind of warning"
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: "ERROR",
      message: "The Data cannot be retrived"
    }
  }
};
</script>

<style scoped>
.list {
  padding: 0px;
  list-style-type: none;
}
.list li {
  margin: 0px;
  padding: 8px 0px 5px 0px;
  border-bottom: 1px solid #dddddd;
}
.list li:last-child {
  border: 0;
}
</style>